module.exports = __webpack_public_path__ + "img/app-download-amazon.0a3248d4.svg";